"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatherEventRoomType = exports.GatherEventMessageRecipientLegacy = exports.GatherEventMessageRecipientBackwardsMigration = exports.GatherEventMessageRecipientMigration = exports.gatherEventProfessionalCategoryOptionToHuman = exports.GatherEventProfessionalCategoryOptionMigration = exports.GATHER_EVENT_PROFESSIONAL_CATEGORIES = exports.gatherEventAttendanceNumberToHuman = exports.GatherEventAttendanceNumberMigration = exports.gatherEventCategoryToHuman = exports.GATHER_EVENT_CATEGORIES = exports.GatherEventCategoryMigration = exports.GatherEventAccessRoleEnumMigration = exports.GatherEventAccessRole = void 0;
const ts_utils_1 = require("../ts-utils");
const client_1 = require("gather-prisma-types/dist/src/public/client");
var GatherEventAccessRole;
(function (GatherEventAccessRole) {
    GatherEventAccessRole["Owner"] = "Owner";
    GatherEventAccessRole["Editor"] = "Editor";
})(GatherEventAccessRole || (exports.GatherEventAccessRole = GatherEventAccessRole = {}));
var GatherEventAccessRoleEnumMigration;
(function (GatherEventAccessRoleEnumMigration) {
    GatherEventAccessRoleEnumMigration["owner"] = "Owner";
    GatherEventAccessRoleEnumMigration["editor"] = "Editor";
})(GatherEventAccessRoleEnumMigration || (exports.GatherEventAccessRoleEnumMigration = GatherEventAccessRoleEnumMigration = {}));
var GatherEventCategoryMigration;
(function (GatherEventCategoryMigration) {
    GatherEventCategoryMigration["Professional or business"] = "ProfessionalOrBusiness";
    GatherEventCategoryMigration["Community or organization"] = "CommunityOrOrganization";
    GatherEventCategoryMigration["Education or academia"] = "EducationOrAcademia";
    GatherEventCategoryMigration["Friends or family"] = "FriendsOrFamily";
    GatherEventCategoryMigration["Other"] = "Other";
})(GatherEventCategoryMigration || (exports.GatherEventCategoryMigration = GatherEventCategoryMigration = {}));
const DEPRECATED_GATHER_EVENT_CATEGORIES = [
    client_1.GatherEventCategory.FriendsOrFamily,
];
exports.GATHER_EVENT_CATEGORIES = Object.values(client_1.GatherEventCategory).filter((x) => !DEPRECATED_GATHER_EVENT_CATEGORIES.includes(x));
exports.gatherEventCategoryToHuman = (0, ts_utils_1.enumToHuman)(client_1.GatherEventCategory, {
    ProfessionalOrBusiness: "Professional or business",
    CommunityOrOrganization: "Community or organization",
    EducationOrAcademia: "Education or academia",
    FriendsOrFamily: "Friends or family",
    Other: "Other",
});
var GatherEventAttendanceNumberMigration;
(function (GatherEventAttendanceNumberMigration) {
    GatherEventAttendanceNumberMigration["0-25"] = "num_0_to_25";
    GatherEventAttendanceNumberMigration["25-50"] = "num_25_to_50";
    GatherEventAttendanceNumberMigration["50-100"] = "num_50_to_100";
    GatherEventAttendanceNumberMigration["100-200"] = "num_100_to_200";
    GatherEventAttendanceNumberMigration["200+"] = "num_200_orMore";
    GatherEventAttendanceNumberMigration["26-100"] = "num_26_to_100Legacy";
    GatherEventAttendanceNumberMigration["101+"] = "num_101_orMoreLegacy";
})(GatherEventAttendanceNumberMigration || (exports.GatherEventAttendanceNumberMigration = GatherEventAttendanceNumberMigration = {}));
exports.gatherEventAttendanceNumberToHuman = (0, ts_utils_1.enumToHuman)(client_1.GatherEventAttendanceNumberPrisma, {
    num_0_to_25: "0-25",
    num_25_to_50: "25-50",
    num_50_to_100: "50-100",
    num_100_to_200: "100-200",
    num_200_orMore: "200+",
    num_26_to_100Legacy: "26-100",
    num_101_orMoreLegacy: "101+",
});
const HIDDEN_PROFESSIONAL_CATEGORIES = [
    client_1.GatherEventProfessionalCategory.NA,
];
exports.GATHER_EVENT_PROFESSIONAL_CATEGORIES = Object.values(client_1.GatherEventProfessionalCategory).filter((x) => !HIDDEN_PROFESSIONAL_CATEGORIES.includes(x));
var GatherEventProfessionalCategoryOptionMigration;
(function (GatherEventProfessionalCategoryOptionMigration) {
    GatherEventProfessionalCategoryOptionMigration["Internal"] = "internal";
    GatherEventProfessionalCategoryOptionMigration["External"] = "external";
    GatherEventProfessionalCategoryOptionMigration["N/A"] = "NA";
})(GatherEventProfessionalCategoryOptionMigration || (exports.GatherEventProfessionalCategoryOptionMigration = GatherEventProfessionalCategoryOptionMigration = {}));
exports.gatherEventProfessionalCategoryOptionToHuman = (0, ts_utils_1.enumToHuman)(client_1.GatherEventProfessionalCategory, {
    internal: "Internal: Attendees are in my team or organization.",
    external: "External: Attendees are outside of my team or organization.",
    NA: "N/A",
});
var GatherEventMessageRecipientMigration;
(function (GatherEventMessageRecipientMigration) {
    GatherEventMessageRecipientMigration["QA"] = "QA";
    GatherEventMessageRecipientMigration["ROOM_CHAT"] = "RoomChat";
})(GatherEventMessageRecipientMigration || (exports.GatherEventMessageRecipientMigration = GatherEventMessageRecipientMigration = {}));
var GatherEventMessageRecipientBackwardsMigration;
(function (GatherEventMessageRecipientBackwardsMigration) {
    GatherEventMessageRecipientBackwardsMigration["QA"] = "QA";
    GatherEventMessageRecipientBackwardsMigration["RoomChat"] = "ROOM_CHAT";
})(GatherEventMessageRecipientBackwardsMigration || (exports.GatherEventMessageRecipientBackwardsMigration = GatherEventMessageRecipientBackwardsMigration = {}));
var GatherEventMessageRecipientLegacy;
(function (GatherEventMessageRecipientLegacy) {
    GatherEventMessageRecipientLegacy["QA"] = "QA";
    GatherEventMessageRecipientLegacy["ROOM_CHAT"] = "ROOM_CHAT";
})(GatherEventMessageRecipientLegacy || (exports.GatherEventMessageRecipientLegacy = GatherEventMessageRecipientLegacy = {}));
var GatherEventRoomType;
(function (GatherEventRoomType) {
    GatherEventRoomType["Talk"] = "Talk";
    GatherEventRoomType["Breakout"] = "Breakout";
    GatherEventRoomType["Booth"] = "Booth";
    GatherEventRoomType["PosterSessions"] = "PosterSessions";
    GatherEventRoomType["Lounge"] = "Lounge";
    GatherEventRoomType["Game"] = "Game";
})(GatherEventRoomType || (exports.GatherEventRoomType = GatherEventRoomType = {}));
//# sourceMappingURL=events.js.map